import { httpClient } from '../httpClient/httpClient';

export interface FreightCost {
  id: number;
  value: number;
}

export interface HandlingFee {
  id: number;
  value: number;
}

export interface PurchaseInformation {
  id: number;
  variantId: number;

  branchId: number;
  isMain: boolean;
  sampleCharge: number;
  surcharge: number;
  mouldCharge: number;
  fixedExchangeRate: number;
  notes: string;
  moq: number;
  supplierId?: number;
  supplierName: string;
  supplierNumber: string;
  freightCostId: number;
  freightCostValue: number;
  handlingFeeId: number;
  handlingFeeValue: number;
  isReady: boolean;
  syncedOn: string | null;
  isEdited: boolean;
}

export interface PurchaseInformationSupplier {
  id: number;
  name: string;
  supplierNumber: string;
}

export interface UpdatePurchaseInformationRequest {
  currencyId: number | null;
  fixedExchangeRate: number;
}

export interface UpdatePurchaseInformationV2Response {
  id: number;
  currencyId: number;
  fixedExchangeRate: number;
  supplierId: number | null;
  articleVariantId: number;
  branchId: number;
}

export const purchaseInformationApi = {
  getPurchaseInformationsFromVariant: (variantId: number) =>
    httpClient.get<PurchaseInformation[]>(
      `purchaseinformations/variant/${variantId}`,
    ),
  getPurchaseInformation: (
    variantId: number,
    branchId: number,
    supplierId: number,
  ) =>
    httpClient.get<PurchaseInformation>(
      `purchaseinformations/${variantId}/${branchId}/${supplierId}`,
    ),
  updatePurchaseInformationV2: (
    purchaseInformationId: number,
    request: UpdatePurchaseInformationRequest,
  ) =>
    httpClient.put<UpdatePurchaseInformationV2Response>(
      `purchaseinformations/${purchaseInformationId}/v2`,
      { data: request },
    ),
};
